module.exports = __webpack_public_path__ + "img/seyahat-saglik-sigortasi.dab53e53.svg";